import hyperform from "hyperform"

import { q, qq } from "../../helper/q"

export const restorePasswordInit = () => {
  const restoreForm = q(".restorePasswordForm")
  if (restoreForm) {
    hyperform.setRenderer("attachWarning", function(warning, element) {
      element.parentNode.classList.add("floatInputError")
      element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
    })
    hyperform(restoreForm)
  }
}
